(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gibbon-responsive-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const PACIFIC_TIME_ZONE = 'America/Los_Angeles';

    const getZonedParts = (formatter, timestamp) => {
      const parts = {};
      formatter.formatToParts(new Date(timestamp)).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return parts;
    };

    const toPacificTimestamp = (dateValue, timeValue) => {
      const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateValue || '');
      const time = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(timeValue || '');
      if (!date || !time) return NaN;

      const target = {
        year: Number(date[1]),
        month: Number(date[2]),
        day: Number(date[3]),
        hour: Number(time[1]),
        minute: Number(time[2]),
        second: Number(time[3] || 0)
      };

      if (
        target.month < 1 || target.month > 12 ||
        target.day < 1 || target.day > 31 ||
        target.hour > 23 || target.minute > 59 || target.second > 59
      ) return NaN;

      const calendarCheck = new Date(Date.UTC(
        target.year,
        target.month - 1,
        target.day,
        target.hour,
        target.minute,
        target.second
      ));
      if (
        calendarCheck.getUTCFullYear() !== target.year ||
        calendarCheck.getUTCMonth() + 1 !== target.month ||
        calendarCheck.getUTCDate() !== target.day
      ) return NaN;

      let formatter;
      try {
        formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: PACIFIC_TIME_ZONE,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (error) {
        return NaN;
      }

      const desired = Date.UTC(
        target.year,
        target.month - 1,
        target.day,
        target.hour,
        target.minute,
        target.second
      );
      let guess = desired;

      for (let index = 0; index < 4; index += 1) {
        const observedParts = getZonedParts(formatter, guess);
        const observed = Date.UTC(
          observedParts.year,
          observedParts.month - 1,
          observedParts.day,
          observedParts.hour,
          observedParts.minute,
          observedParts.second
        );
        const adjustment = desired - observed;
        guess += adjustment;
        if (adjustment === 0) break;
      }

      const finalParts = getZonedParts(formatter, guess);
      const isExact =
        finalParts.year === target.year &&
        finalParts.month === target.month &&
        finalParts.day === target.day &&
        finalParts.hour === target.hour &&
        finalParts.minute === target.minute &&
        finalParts.second === target.second;

      return isExact ? guess : NaN;
    };

    if (!customElements.get('gibbon-schedule')) {
      class GibbonSchedule extends HTMLElement {
        connectedCallback() {
          this.handleVisibilityChange = () => {
            if (!document.hidden) this.update();
          };
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          this.update();
        }

        disconnectedCallback() {
          window.clearTimeout(this.boundaryTimer);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }

        update() {
          window.clearTimeout(this.boundaryTimer);

          if (this.dataset.designMode === 'true' || this.dataset.enabled !== 'true') {
            this.hidden = false;
            return;
          }

          const startDate = this.dataset.startDate || '';
          const endDate = this.dataset.endDate || '';
          const start = startDate
            ? toPacificTimestamp(startDate, this.dataset.startTime || '00:00')
            : null;
          const end = endDate
            ? toPacificTimestamp(endDate, this.dataset.endTime || '23:59')
            : null;

          if (
            (startDate && !Number.isFinite(start)) ||
            (endDate && !Number.isFinite(end)) ||
            (Number.isFinite(start) && Number.isFinite(end) && end <= start)
          ) {
            this.hidden = true;
            return;
          }

          const now = Date.now();
          const isAfterStart = !Number.isFinite(start) || now >= start;
          const isBeforeEnd = !Number.isFinite(end) || now < end;
          this.hidden = !(isAfterStart && isBeforeEnd);

          const nextBoundary = Number.isFinite(start) && now < start
            ? start
            : (Number.isFinite(end) && now < end ? end : null);
          if (nextBoundary) {
            const delay = Math.min(Math.max(nextBoundary - now + 50, 50), 2147483647);
            this.boundaryTimer = window.setTimeout(() => this.update(), delay);
          }
        }
      }

      customElements.define('gibbon-schedule', GibbonSchedule);
    }

    if (!customElements.get('gibbon-video-control')) {
      class GibbonVideoControl extends HTMLElement {
        connectedCallback() {
          this.video = this.closest('.gibbon-rb__stage')?.querySelector('.gibbon-rb__video');
          this.button = this.querySelector('[data-video-toggle]');
          this.label = this.querySelector('[data-video-label]');
          if (!this.video || !this.button) return;

          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handleClick = () => {
            if (this.video.paused) {
              const playPromise = this.video.play();
              if (playPromise) playPromise.catch(() => this.update());
            } else {
              this.video.pause();
            }
            this.update();
          };
          this.handleStateChange = () => this.update();
          this.handleMotionChange = () => {
            if (this.motionQuery.matches) this.video.pause();
            this.update();
          };

          this.button.addEventListener('click', this.handleClick);
          this.video.addEventListener('play', this.handleStateChange);
          this.video.addEventListener('pause', this.handleStateChange);
          if (this.motionQuery.addEventListener) {
            this.motionQuery.addEventListener('change', this.handleMotionChange);
          } else {
            this.motionQuery.addListener(this.handleMotionChange);
          }

          this.handleMotionChange();
        }

        disconnectedCallback() {
          if (!this.video || !this.button) return;
          this.button.removeEventListener('click', this.handleClick);
          this.video.removeEventListener('play', this.handleStateChange);
          this.video.removeEventListener('pause', this.handleStateChange);
          if (this.motionQuery?.removeEventListener) {
            this.motionQuery.removeEventListener('change', this.handleMotionChange);
          } else if (this.motionQuery) {
            this.motionQuery.removeListener(this.handleMotionChange);
          }
        }

        update() {
          const isPaused = this.video.paused;
          const action = isPaused ? 'Play' : 'Pause';
          this.button.setAttribute('aria-label', `${action} background video`);
          if (this.label) this.label.textContent = `${action} video`;
        }
      }

      customElements.define('gibbon-video-control', GibbonVideoControl);
    }

    if (!customElements.get('gibbon-countdown')) {
      class GibbonCountdown extends HTMLElement {
        connectedCallback() {
          this.disconnected = false;
          this.endTime = toPacificTimestamp(
            this.dataset.endDate,
            this.dataset.endTime || '00:00'
          );

          if (!Number.isFinite(this.endTime)) {
            this.hidden = true;
            return;
          }

          this.timer = this.querySelector('[data-countdown-timer]');
          this.expired = this.querySelector('[data-countdown-expired]');
          this.tick();
          if (this.endTime > Date.now()) {
            this.interval = window.setInterval(() => this.tick(), 1000);
          }
        }

        disconnectedCallback() {
          this.disconnected = true;
          window.clearInterval(this.interval);
        }

        setUnit(unit, value) {
          const output = this.querySelector(`[data-countdown-unit="${unit}"]`);
          if (output) output.textContent = String(value).padStart(2, '0');
        }

        tick() {
          if (this.disconnected) return;
          const remaining = Math.max(0, this.endTime - Date.now());
          let seconds = Math.floor(remaining / 1000);
          const days = Math.floor(seconds / 86400);
          seconds -= days * 86400;
          const hours = Math.floor(seconds / 3600);
          seconds -= hours * 3600;
          const minutes = Math.floor(seconds / 60);
          seconds -= minutes * 60;

          this.setUnit('days', days);
          this.setUnit('hours', hours);
          this.setUnit('minutes', minutes);
          this.setUnit('seconds', seconds);
          if (this.timer) {
            this.timer.setAttribute(
              'aria-label',
              `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`
            );
          }

          if (remaining > 0) return;
          window.clearInterval(this.interval);
          const action = this.dataset.expiryAction || 'hide';
          if (action === 'hide') {
            const block = this.closest('.gibbon-rb__block');
            if (block) block.hidden = true;
          } else if (action === 'message') {
            if (this.timer) this.timer.hidden = true;
            if (this.expired) {
              this.expired.hidden = false;
              this.expired.setAttribute('aria-live', 'polite');
            }
          }
        }
      }

      customElements.define('gibbon-countdown', GibbonCountdown);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
